module.exports = __webpack_public_path__ + "img/dinersclub.9c707379.svg";